/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Definition of the assets contained in the domain
 */
export type PublicDomainContentDefinitionDto = {
    /**
     * Type of the domain content definition
     */
    type: PublicDomainContentDefinitionDto.type;
};

export namespace PublicDomainContentDefinitionDto {

    /**
     * Type of the domain content definition
     */
    export enum type {
        STATIC = 'STATIC',
        DYNAMIC = 'DYNAMIC',
    }


}
